import styled from 'styled-components'
import { Modal } from 'semantic-ui-react'

export const StyledModal = styled(Modal)`
  .support-method {
    line-height: 1.5em;
    margin-bottom: 0.3em;
  }

  .method {
    display: inline-block;
    text-transform: uppercase;
    width: 4.5em;
    font-weight: bold;
    font-size: 0.8em;
    margin: 0 0.8em 0 0;
    text-align: right;
  }
`
